import { STORAGE_KEYS } from './constants';

// Görüşme başladıktan sonra odadan ayrılan kullanıcı, sitenin her sayfasında
// "sohbete dön" baloncuğu ile odaya geri dönebilsin diye bağlantı saklanır.
// Oturum bitince/geçersizleşince temizlenir; aksi halde fallback TTL devreye girer.

const GRACE_MS = 5 * 60 * 1000;
const FALLBACK_TTL_MS = 24 * 60 * 60 * 1000;

export function saveChatReturn(token, { endsAt } = {}) {
  if (!token || typeof window === 'undefined') return;
  try {
    const endsMs = endsAt ? new Date(endsAt).getTime() : NaN;
    const expiresAt = Number.isFinite(endsMs)
      ? endsMs + GRACE_MS
      : Date.now() + FALLBACK_TTL_MS;
    const entry = {
      url: `/consulting?token=${encodeURIComponent(token)}`,
      savedAt: Date.now(),
      expiresAt
    };
    window.localStorage.setItem(STORAGE_KEYS.ACTIVE_CHAT_RETURN, JSON.stringify(entry));
  } catch {
    // localStorage kullanılamıyorsa sessizce geç
  }
}

export function getChatReturn() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEYS.ACTIVE_CHAT_RETURN);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (!entry?.url) return null;
    if (entry.expiresAt && Date.now() > entry.expiresAt) {
      clearChatReturn();
      return null;
    }
    return entry;
  } catch {
    return null;
  }
}

export function clearChatReturn() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEYS.ACTIVE_CHAT_RETURN);
  } catch {
    // yoksay
  }
}
